import { LayerDefinition } from './types';

export const valleyFogDefinition: LayerDefinition = {
  id: 'valley_fog',
  name: 'Low-Lying Valley Fog',
  category: 'core_met',
  categoryLabel: 'Core Meteorological',
  icon: '🌫️',
  description: 'Radiation & inversion valley fog formation risk. Forecasts likelihood of low lying fog development.',
  sourceModels: ['hrrr', 'rrfs', 'rdps', 'nbm', 'gdps'],
  outputModels: ['Fog probability .pmtiles per model'],
  config: {
    defaultModel: 'hrrr'
  }
};

export default valleyFogDefinition;
